import { Vector3 as r, Euler as y } from "three";
import { DegToRadV3 as i } from "./index5.js";
const p = new r(), e = new y(), m = new r(), t = new r(), a = new r();
function f(c, o, n = new r()) {
  return n.fromArray(o.pos), p.fromArray(c), e.fromArray(i(o.rot)), m.fromArray(o.anchor), t.fromArray(o.size), n.sub(a.copy(t).multiply(m).applyEuler(e)).add(a.copy(t).multiply(p).applyEuler(e));
}
export {
  f as getPivot
};
//# sourceMappingURL=index12.js.map
